<template>
<div class="mobile_wrap_aboutus wow fadeInUp">
 <el-row>
  <el-col :span="1" class="header_block"></el-col>
  <el-col :span="22" >
       <div  v-for="(item,index) in serviceArray"  :key="index" class="header_block server_box">
        <img :src="item.url" class="server_img" />
        <p class="server_title">{{item.title}}</p>
        <p class="server_titleEng">{{item.titleEng}}</p>
       </div>
  </el-col>
  <el-col :span="1" class="header_block"></el-col>
</el-row>
</div>
</template>

<script>
export default {
  name: 'aboutustab',
  // props: {
  //   serviceArray: {
  //     type: Array,
  //     default: () => {
  //       return []
  //     },
  //   }
  // },
  data() {
    return {
      serviceArray:[
        {url:require('@/assets/imgs/eighttwo.jpg'),title:'企业定位',titleEng:'星沐互娱不是艺术家，我们是影像服务商，我们用靠谱两个字给自己和我们提供的服务贴上不同的标签。'},
        {url:require('@/assets/imgs/eightthree.jpg'),title:'服务理念',titleEng:'想办法——我们竭尽全力的为客户提供可行的解决方案。'},
        {url:require('@/assets/imgs/eightfour.jpg'),title:'发展理念',titleEng:'慢慢来，比较快。'},
      ],
    }
  },

  mounted() {
    this.$nextTick(() => {
      // 在dom渲染完后,再执行动画
      // const wow = new WOW({
      //   live: false
      // })
      // wow.init()
      new this.$wow.WOW({
        live:true
      }).init()
    })
  },
  // methods:{
  //   handleScroll(){
  //     this.$nextTick(()=>{
	// 	let scrollTop = document.body.scrollTop || document.documentElement.scrollTop || window.pageYOffset
  //    if (scrollTop > 60) {
  //      this.logoIndex = 1
  //      this.classNames = "nav_bg_white_add"
  //      this.menuClassNames = "menu_each each_toggle"
  //       } else {
  //      this.logoIndex = 0
  //      this.classNames = "nav_bg_white_reduce"
  //      this.menuClassNames = "menu_each "
  //       }
	// })
  //   }
  // }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less">
.mobile_wrap_aboutus{
  .header_block{
    min-height:10px
    }
  }
      .server_box{
      width: 33.333%;
      float: left;
      display: flex;
      flex-direction: column;
      align-items: center;
      .server_img{
        width: 95%;
        // border-radius: 50%;
      }
      .server_title{
font-size: 16px;
    color: #363636;
    margin-top: 34px
}
.server_titleEng{
  font-size: 14px;
    color: #8d8d8d;
    margin-top: 8px;
    text-align: center;
    margin-top: 20px;
    line-height: 30px;
    padding: 0 5px;
    text-align: left;
}
  
}
</style>



